export const CardCollection = {
  transclude: true,

  bindings: {
    heading: '<',
    description: '<',
    img: '<',
  },

  template: `
    <div class="card card-collection border-0 pointer">
      <div class="card-img-wrapper bg-mask-overlay">
        <image-background src="$ctrl.img"></image-background>
      </div>
      <div class="card-block text-left p-1 pl-4 pt-4">
        <header>
          <h4 class="card-title word-wrap mb-2">{{ $ctrl.heading }}</h4>
        </header>
        <p class="card-text">{{ $ctrl.description }}</p>
        <ng-transclude></ng-transclude>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Card/CardCollection.js